import { render } from "./BuilderControlsButtons.vue?vue&type=template&id=32c9640f&scoped=true&ts=true&lang=pug"
import script from "./BuilderControlsButtons.vue?vue&type=script&setup=true&lang=ts"
export * from "./BuilderControlsButtons.vue?vue&type=script&setup=true&lang=ts"

import "./BuilderControlsButtons.vue?vue&type=style&index=0&id=32c9640f&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32c9640f"]])

export default __exports__